import React from 'react';
import { makeStyles, Grid, useTheme, useMediaQuery } from '@material-ui/core';
import MyAccountSideMenu from './components/MyAccountSideMenu';
import ReviewContainer from './components/Review/ReviewContainer';
import ProfileContainer from './components/Profile/ProfileContainer';
import MyPageEditContainer from './components/Edit/MyPageEditContainer';
import { MyAccountContext } from './MyAccountContainer';
import MemberShipWithdrawal from './components/MemberShipWithdrawal';
import WithdrawalSuccessScreen from './components/MemberShipWithdrawal/WithdrawalSuccessScreen';
import NotificationContainer from './components/Notification';
import { BankAccount } from './components/BankAccount';

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 960,
    margin: '0px auto',
    padding: '58px 0px',
    minHeight: '100vh',
    [theme.breakpoints.down('md')]: {
      maxWidth: 'unset',
      padding: '0px 0px 24px 0px',
      // paddingTop: (props: { current?: string }) =>
      //   !props.current?.includes('withdrawal') ? '24px' : '0px',
      justifyContent: 'center'
    }
  },
  left: {
    maxWidth: 186,
    width: '100%',
    height: '100%',
    [theme.breakpoints.down('md')]: {
      maxWidth: 'initial',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  },
  right: {
    width: '100%',
    [theme.breakpoints.down('md')]: {}
  },
  drawerRoot: {
    width: '100%',
    height: 'calc(100% - 113px)',
    top: 48
  },
  paper: {
    height: 'calc(100% - 113px)',
    top: 48
  }
}));

interface Props {
  refetch: () => void;
}

const MyAccountPresenter: React.FC<Props> = ({ refetch }) => {
  const context = React.useContext(MyAccountContext);
  const mdDown = useMediaQuery(useTheme().breakpoints.down('md'));
  const classes = useStyles({ current: context.current });

  if (context.current === 'withdrawal-complete') {
    return <WithdrawalSuccessScreen />;
  }

  return (
    <Grid container className={classes.root} wrap={mdDown ? 'wrap' : 'nowrap'}>
      {!context.mobileMenuOpen && (
        <Grid item className={classes.left}>
          <MyAccountSideMenu />
        </Grid>
      )}

      {!mdDown ? (
        <React.Fragment>
          <Grid item style={{ width: 84 }} />
          <Grid item className={classes.right}>
            {(context.current === '' || context.current === 'profile') && (
              <ProfileContainer />
            )}
            {context.current === 'review' && <ReviewContainer />}
            {context.current === 'edit' && <MyPageEditContainer />}
            {context.current === 'membership-withdrawal' && (
              <MemberShipWithdrawal />
            )}
            {context.current === 'notification' && (
              <NotificationContainer refetch={refetch} />
            )}
            {context.current === 'backAccount' && <BankAccount />}
          </Grid>
        </React.Fragment>
      ) : (
        <React.Fragment>
          {context.mobileMenuOpen && (
            <Grid item className={classes.right}>
              {context.current === 'profile' && <ProfileContainer />}
              {context.current === 'review' && <ReviewContainer />}
              {context.current === 'edit' && <MyPageEditContainer />}
              {context.current === 'membership-withdrawal' && (
                <MemberShipWithdrawal />
              )}
              {context.current === 'notification' && (
                <NotificationContainer refetch={refetch} />
              )}
              {context.current === 'backAccount' && <BankAccount />}
            </Grid>
          )}
        </React.Fragment>
      )}
    </Grid>
  );
};
export default MyAccountPresenter;
